/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export const extractError = (e) => {
    const error = e;
    let message;
    if (error?.cause) {
        const { cause } = error;
        message = cause;
    }
    else {
        message = { error };
    }
    return message;
};
export const formatRunError = (e) => {
    if (typeof e === "string") {
        return e;
    }
    if (e instanceof Error) {
        return e.message;
    }
    if ("message" in e) {
        return e.message;
    }
    // Presume it's an ErrorObject.
    const error = e.error;
    if (typeof error === "string") {
        return error;
    }
    if ("message" in error) {
        return error.message;
    }
    return JSON.stringify(error);
};
//# sourceMappingURL=error.js.map